import React from 'react';

let SingleOrder=props=>{
    let ingredientSummary=props.order.ingredient.map(item=>{
        return <span className="border p-1 m-1" key={Math.random()}>
            {item.type}*{item.amount}
        </span>
    })
    return(
        <div className="border p-3 m-3">
            <p>{props.order.customer.address}</p>
            <p>{props.order.customer.phone}</p>
            <p>{props.order.customer.delivery}</p>
            <p>Total Price : {props.order.totalPrice}</p>
            <p>{props.order.orderTime}</p>
            <div>
               {ingredientSummary}
            </div>
        </div>
    )
}

export default SingleOrder;